import { UPDATE_BOOKING_SERVICE } from './../actions/booking-service';

const initialState = {
  tripValues: {
    adultNumber: 1,
    childNumber: 0,
    infantNumber: 0,
    petNumber: 0,
    totalNumber: 1,
    fromCity: null,
    toCity: null,
    departDate: null,
    returnDate: null,
    supplirService: 0,
  },
  flightType: {
    roundTrip: false,
    onewayTrip: true,
    //multicityTrip: false
  },
};

/**
 * @param {Object} state
 * @param {Object} action
 * @returns {Object}
 */
export default function alertReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_BOOKING_SERVICE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
